import config from "./config/config";

export const extractDashboardSubdomain = (url: string): string | undefined => {
  // Pattern: Protocol -> Negative lookahead for 'www' -> Capture Group -> .dashboard
  const pattern = /https?:\/\/(?!www\.)([^.]+)\.dashboard/;
  const match = url.match(pattern);

  if (match) return match[1];
};

export const isSupportedSubdomain = (subdomain: string) => config.ALLOWED_IDPS.includes(subdomain);

export const mergeUnique = <T, K>(
    list1: T[],
    list2: T[],
    key: (item: T) => K,
): T[] => {
    // If two items have the same key, but are actually different the first one encountered will be used
    const map = new Map<K, T>();
    list1.forEach(item => {
        if (!map.has(key(item))) {
            map.set(key(item), item);
        }
    });
    list2.forEach(item => {
        if (!map.has(key(item))) {
            map.set(key(item), item);
        }
    });
    return [...map.values()];
};

export function formatTimePassed(ms: number) {
    const totalSeconds = Math.floor(ms / 1000);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;

    const mmss = `${m.toString().padStart(2, '0')}:${s
        .toString()
        .padStart(2, '0')}`;

    if (h) {
        return `${h}:${mmss}`;
    }
    return mmss;
}